import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminRoute from "./components/AdminRoute";
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import Congratulations from "./components/Congratulations";
import TaablAdminRoute from "./components/TaablAdminRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Address from "./containers/Address";
import ApprovalRequests from "./containers/ApprovalRequests";
import BlackScholes from "./containers/BlackScholes";
import ChangeEmail from "./containers/ChangeEmail";
import Contributions from "./containers/Contributions";
import EditObj from "./containers/EditObj";
import EmployeeHome from "./containers/EmployeeHome";
import ExceptionReport from "./containers/ExceptionReport";
import ExpenseDashboard from "./containers/ExpenseDashboard";
import Home from "./containers/Home";
import ImportData from "./containers/ImportData";
import Login from "./containers/Login";
import ManualPayments from "./containers/ManualPayments";
import MoneyCalculator from "./containers/MoneyCalculator";
import NewNote from "./containers/NewNote";
import NonAcceptHome from "./containers/NonAcceptHome";
import Notes from "./containers/Notes";
import NotFound from "./containers/NotFound";
import ObjectList from "./containers/ObjectList";
import OfferingPeriod from "./containers/OfferingPeriod";
import PeriodEndReport from "./containers/PeriodEndReport";
import Personalization from "./containers/Personalization";
import BankInformation from "./containers/Personalization/BankInformation";
import LinkBrokerageAccount from "./containers/Personalization/LinkBrokerageAccount";
import VerifyBankAccount from "./containers/Personalization/VerifyBankAccount";
import PlanDetails from "./containers/PlanDetails";
import PlanSignUp from "./containers/PlanSignUp";
import Reports from "./containers/Reports";
import ResetPassword from "./containers/ResetPassword";
import Settings from "./containers/Settings/index";
import SignUp from "./containers/SignUp";
import SignupEvents from "./containers/SignupEvents";
import TaablSignUp from "./containers/TaablSignup";
import TermsAndConditions from "./containers/TermsAndConditions";
import Transactions from "./containers/Transactions";
import TaablAdminUsers from "./containersTaabl/TaablAdminUsers";

export default function Routes({ appProps }) {
  return (
    <Switch>
      <AppliedRoute path="/" exact component={Home} appProps={appProps} />

      <UnauthenticatedRoute
        path="/login"
        exact
        component={Login}
        appProps={appProps}
      />
      <UnauthenticatedRoute
        path="/signup"
        exact
        component={SignUp}
        appProps={appProps}
      />
      <UnauthenticatedRoute
        path="/taablsignup"
        exact
        component={TaablSignUp}
        appProps={appProps}
      />
      <UnauthenticatedRoute
        path="/moneycalculator"
        exact
        component={MoneyCalculator}
        appProps={appProps}
      />
      <TermsAndConditions
        path="/termsandconditions"
        exact
        component={TermsAndConditions}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/aboutPlan"
        exact
        component={NonAcceptHome}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/planSignup"
        exact
        component={PlanSignUp}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/notes/new"
        exact
        component={NewNote}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/notes/:id"
        exact
        component={Notes}
        appProps={appProps}
      />
      <AdminRoute
        path="/editObj/:editObj"
        exact
        component={EditObj}
        appProps={appProps}
      />
      <UnauthenticatedRoute
        path="/login/reset"
        exact
        component={ResetPassword}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/settings"
        exact
        component={Settings}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/address"
        exact
        component={Address}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/personalization"
        exact
        component={Personalization}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/brokerageaccount"
        exact
        component={LinkBrokerageAccount}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/bankinformation"
        exact
        component={BankInformation}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/verifybankinformation"
        exact
        component={VerifyBankAccount}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/onboardingcomplete"
        exact
        component={Congratulations}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/settings/email"
        exact
        component={ChangeEmail}
        appProps={appProps}
      />
      <AdminRoute
        path="/employeeDashboard/:id"
        exact
        component={EmployeeHome}
        appProps={appProps}
      />

      <AdminRoute
        path="/expenseDashboard"
        exact
        component={ExpenseDashboard}
        appProps={appProps}
      />
      <AdminRoute
        path="/exceptionreport"
        exact
        component={ExceptionReport}
        appProps={appProps}
      />
      <AdminRoute
        path="/reports"
        exact
        component={Reports}
        appProps={appProps}
      />
      <AdminRoute
        path="/contributions/:contributionObj"
        exact
        component={Contributions}
        appProps={appProps}
      />
      <TaablAdminRoute
        path="/settings/list/Company"
        exact
        component={ObjectList}
        appProps={appProps}
      />
      <TaablAdminRoute
        path="/signupevents"
        exact
        component={SignupEvents}
        appProps={appProps}
      />
      <TaablAdminRoute
        path="/approvals"
        exact
        component={ApprovalRequests}
        appProps={appProps}
      />
      <TaablAdminRoute
        path="/repayment"
        exact
        component={ManualPayments}
        appProps={appProps}
      />
      <TaablAdminRoute
        path="/transactions"
        exact
        component={Transactions}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/planDetails"
        exact
        component={PlanDetails}
        appProps={appProps}
      />
      <AuthenticatedRoute
        path="/blackScholes"
        exact
        component={BlackScholes}
        appProps={appProps}
      />
      <AdminRoute
        path="/settings/list/period"
        exact
        component={ObjectList}
        appProps={appProps}
      />
      <AdminRoute
        path="/settings/list/User"
        exact
        component={ObjectList}
        appProps={appProps}
      />
      <AdminRoute
        path="/settings/list/TaablAdmin/User"
        exact
        component={TaablAdminUsers}
        appProps={appProps}
      />
      <AdminRoute
        path="/settings/list/TaablAdmin/offeringPeriod"
        exact
        component={OfferingPeriod}
        appProps={appProps}
      />
      <AdminRoute
        path="/periodendreport"
        exact
        component={PeriodEndReport}
        appProps={appProps}
      />
      <AdminRoute
        path="/imports"
        exact
        component={ImportData}
        appProps={appProps}
      />

      {/* Finally, catch all unmatched routes */}
      <Route component={NotFound} />
    </Switch>
  );
}
